import React, { FC } from "react";
import ErrorComponent from "components/common/Error/index";

const ErrorPage: FC = () => {
  return <ErrorComponent />;
};

export default ErrorPage;
